import React, {useState, useRef, useEffect, useContext} from 'react';
import Header from '../../components/header';
import {useLocation, useNavigate, useNavigation, useParams} from "react-router-dom";
import axios from "axios";
import {baseURL} from "../../services/api";
import AuthContext from '../../components/shared/AuthContext';
import DataTable from "react-data-table-component";
import UpClient from "../../components/UpClient";
import GoBack from "../../components/goBack";

const UpdateClient = (props,goback=true) => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [displayEdit, setDisplayEdit] = useState('none');
    const location = useLocation();
    console.log(location.state?.client);
    return (
        <>
            <div className="main-container container-fluid">
                {goback ? <GoBack route='/clients/list' /> : null}
                <UpClient type={props.clientType} client={location.state?.client}/>
            </div>
        </>
    );
}

export default UpdateClient;